import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  algo values
export const Algovalues = createSlice({
  name: "Algovalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Algovalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Algovalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Algovalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Algovalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Algovalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchalgo:(state)=>{
        state.switch = false
    }
  },
});
export default Algovalues.reducer;
export const {
    Algovalues_datagrid,
  success_api_call_Algovalues_datagrid,
  failure_api_call_Algovalues_datagrid,
  create_Algovalues_datagrid_complete_api,
  Algovalues_datagrid_is_success,false_switchalgo
} = Algovalues.actions;
